export const SUPPORT_EMAIL = 'support@bondsports.co';
export const GOOGLE_API_KEY =  process.env.GOOGLE_API_KEY || 'missing-google-key';